import React from 'react';

import { Card, FormItem } from '../../../components';
import { Input } from '../../../components/Input';
import { UserConfidenceRangesList } from '../../../components/UserConfidenceRangesList';
import type { AgentForm as AgentFormType } from '../../../utilities';
import { makeRangeValidator } from '../utils/validators';
import { validateUserConfidenceRanges } from '../utils/validateUserConfidenceRanges';

export type UserConfidenceSettingsProps = {
  disabled?: boolean;
};

export const UserConfidenceSettings: React.FC<UserConfidenceSettingsProps> = ({
  disabled,
}) => {
  return (
    <Card
      collapsable
      size="unset"
      title="User Confidence Ranges"
      name="agentpage.userConfidenceRanges"
      contentClassName="flex flex-col gap-y-md"
      subtitle="Map STT confidence scores to message templates. When confidence falls within a range its template is applied, with {user_turn} replaced by the transcribed text."
      withOverflow={false}
    >
      <FormItem<AgentFormType>
        name="missing_confidence_default"
        label="Missing confidence default (0–1)"
        tooltip="Confidence value assumed when the STT engine does not provide a score. Range: 0–1, default 1."
        validate={makeRangeValidator(0, 1)}
      >
        <Input numeric roundTo={4} min={0} max={1} disabled={disabled} />
      </FormItem>

      <FormItem<AgentFormType>
        name="user_confidence_ranges"
        label="Confidence ranges"
        inline={false}
        validate={validateUserConfidenceRanges}
        renderError={() => null}
      >
        <UserConfidenceRangesList disabled={disabled} />
      </FormItem>
    </Card>
  );
};
